import { CALL_API, Schemas } from '../../common/middleware/api';

export const PAYMENT_METHODS_REQUEST = 'PAYMENT_REQUEST';
export const PAYMENT_METHODS_SUCCESS = 'PAYMENT_SUCCESS';
export const PAYMENT_METHODS_FAILURE = 'PAYMENT_FAILURE';

export const PAYMENT_CONFIGURATION_FETCH_REQUEST = 'PAYMENT_CONFIGURATION_GET_REQUEST';
export const PAYMENT_CONFIGURATION_FETCH_SUCCESS = 'PAYMENT_CONFIGURATION_GET_SUCCESS';
export const PAYMENT_CONFIGURATION_FETCH_FAILURE = 'PAYMENT_CONFIGURATION_GET_FAILURE';

export const PAYMENT_CONFIGURATION_CREATE_REQUEST = 'PAYMENT_CONFIGURATION_CREATE_REQUEST';
export const PAYMENT_CONFIGURATION_CREATE_SUCCESS = 'PAYMENT_CONFIGURATION_CREATE_SUCCESS';
export const PAYMENT_CONFIGURATION_CREATE_FAILURE = 'PAYMENT_CONFIGURATION_CREATE_FAILURE';

export const PAYMENT_CONFIGURATION_UPDATE_REQUEST = 'PAYMENT_CONFIGURATION_UPDATE_REQUEST';
export const PAYMENT_CONFIGURATION_UPDATE_SUCCESS = 'PAYMENT_CONFIGURATION_UPDATE_SUCCESS';
export const PAYMENT_CONFIGURATION_UPDATE_FAILURE = 'PAYMENT_CONFIGURATION_UPDATE_FAILURE';

export const loadPaymentMethods = (options, onSuccess) => ({
	[CALL_API]: {
		types: [PAYMENT_METHODS_REQUEST, PAYMENT_METHODS_SUCCESS, PAYMENT_METHODS_FAILURE],
		endpoint: 'api/paymentMethods/unpaged',
		request: options,
		schema: Schemas.PAYMENT_METHODS_BY_OWNER,
		onSuccessEvent: onSuccess
	}
});

export const fetchPaymentConfiguration = (id) => ({
	[CALL_API]: {
		types: [PAYMENT_CONFIGURATION_FETCH_REQUEST, PAYMENT_CONFIGURATION_FETCH_SUCCESS, PAYMENT_CONFIGURATION_FETCH_FAILURE],
		endpoint: `api/paymentConfigurations/${id}`,
		schema: Schemas.PAYMENT_CONFIGURATION
	}
});

export const createPaymentConfiguration = (paymentConfiguration, onSuccessEvent) => ({
	[CALL_API]: {
		types: [PAYMENT_CONFIGURATION_CREATE_REQUEST, PAYMENT_CONFIGURATION_CREATE_SUCCESS, PAYMENT_CONFIGURATION_CREATE_FAILURE],
		endpoint: 'api/paymentConfigurations',
		method: 'POST',
		request: paymentConfiguration,
		schema: Schemas.PAYMENT_CONFIGURATION,
		form: 'paymentConfiguration',
		onSuccessEvent
	}
});

export const updatePaymentConfiguration = (id, paymentConfiguration, onSuccessEvent) => ({
	[CALL_API]: {
		types: [PAYMENT_CONFIGURATION_UPDATE_REQUEST, PAYMENT_CONFIGURATION_UPDATE_SUCCESS, PAYMENT_CONFIGURATION_UPDATE_FAILURE],
		endpoint: `api/paymentConfigurations/${id}`,
		method: 'PUT',
		request: paymentConfiguration,
		schema: Schemas.PAYMENT_CONFIGURATION,
		form: 'paymentConfiguration',
		onSuccessEvent
	}
});